export default __webpack_public_path__ + "static/media/BNB_TINY_BLACK.ba92e6ea.svg";